import { useCallback, useState } from 'react';

type FeedbackDialogState = [boolean, () => void, () => void];

export const useFeedbackDialogState = ({
  onMenuClose
}: {
  onMenuClose: () => void;
}): FeedbackDialogState => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const onMenuItemClick = useCallback(() => {
    onMenuClose();
    setDialogOpen(true);
  }, [onMenuClose, setDialogOpen]);

  const onClose = useCallback(() => {
    setDialogOpen(false);
  }, [setDialogOpen]);

  return [dialogOpen, onMenuItemClick, onClose];
};
